export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/selected-star-icon.png?8bf913ccef025d6fcaeb1f735c592616";